var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInstructions = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0V14.0002H12V0H0ZM11 13.0002H1V1H11V13.0002ZM7.00031 4.00031H3.00031V3.00031H7.00031V4.00031ZM9.00031 6.00049H3.00031V5.00049H9.00031V6.00049ZM7.00031 8.00073H3.00031V7.00073H7.00031V8.00073ZM5.00031 10.0009H3.00031V9.00092H5.00031V10.0009Z",
  fill: "#E00C69"
})));
export { SvgInstructions as ReactComponent };
export default __webpack_public_path__ + "assets/icons/instructions.e13d9e.svg";